(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/process-data/remove-closed-joker.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/process-data/remove-closed-joker.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const productMapping = svs.numbergames.productMapping;
function removeClosedJoker(_ref) {
  let next = _ref.next,
    wagers = _ref.wagers,
    productWithClosedJoker = _ref.productWithClosedJoker,
    price = _ref.price;
  const closedJokerId = productMapping.getJokerProductId(productWithClosedJoker);
  wagers = wagers.map(wager => _objectSpread(_objectSpread({}, wager), {}, {
    bets: wager.bets.filter(_ref2 => {
      let productId = _ref2.productId;
      return productId !== closedJokerId;
    })
  }));
  price = wagers.reduce((acc, wager) => acc + wager.bets.reduce((acc, bet) => acc + parseInt(bet.betAmountSalesGroup1, 10) + parseInt(bet.betAmountSalesGroup2, 10), 0), 0);
  next({
    wagers,
    price
  });
}
svs.numbergames.pay_numbergames.removeClosedJoker = removeClosedJoker;

 })(window);